import { render } from "./BigudMain.vue?vue&type=template&id=7bdf660b&scoped=true"
import script from "./BigudMain.vue?vue&type=script&lang=js"
export * from "./BigudMain.vue?vue&type=script&lang=js"

import "./BigudMain.vue?vue&type=style&index=0&id=7bdf660b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdf660b"]])

export default __exports__